import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingMode } from '../../enums/LoadingMode.enum';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner],
})
export class LoadingComponent {
  readonly loadingMode = input<LoadingMode>();
  readonly spinnerDiameter = input<number | undefined>();
  readonly isTableInsideDialog = input<boolean>(false);
  protected readonly LoadingMode = LoadingMode;

  protected get loaderClass(): string {
    switch (this.loadingMode()) {
      case LoadingMode.TABLE:
        return `table-loading-spinner ${this.isTableInsideDialog() ? 'inside-dialog' : ''}`;
      case LoadingMode.VIEW:
        return 'view-loading-spinner';
      case LoadingMode.OVERLAY:
        return 'loading-overlay';
      case LoadingMode.FULLSCREEN:
        return 'loading-fullscreen';
    }
  }
}
